export async function fetchWorkflowDropdown(app, params) {
  const { searchTerm } = params;
  const workflowService = app.service('workflow');
  const workflowDropdown = await workflowService.get('dropdown', { search_term: searchTerm });
  const workflowDropdownData = (workflowDropdown || {}).data || [];

  return workflowDropdownData;
}